import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatchingDonationCardComponent } from './components/matching-donation-card/matching-donation-card.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [MatchingDonationCardComponent],
  exports: [MatchingDonationCardComponent],
})
export class MatchingDonationCardModule { }
